<template>
  <div class="own-program section">
    <svg class="delimiter" viewBox="0 0 100 40" preserveAspectRatio="none">
      <path
        class="delimiter__shape"
        d="M 0 0 L 100 0 L 100 20 C 60 0 30 40 0 20"
      />
    </svg>
    <h2 class="section-title">
      Jesteś zainteresowany naszym programem własnym?
    </h2>
    <div class="program">
      <div
        class="column is-8-desktop is-offset-2-desktop is-12-tablet is-offset-0-tablet"
      >
        <div class="box">
          <p class="box-title">Dziś w TV</p>
          <loader :state="programState">
            <div class="program-list" v-if="todayProgram">
              <program-block
                v-for="block in todayProgram.blocks"
                :name="block.name"
                :items="block.items"
                :current="today"
                :now="now"
                :key="block.id"
              />
            </div>
            <p class="grey-message" v-else>
              Brak przewidzianego programu na dziś
            </p>

            <template #loading>
              <div class="spinner is-3by4 is-medium is-grey-lighter"></div>
            </template>

            <template #error>
              <div class="grey-message">
                <icon name="fa-times-circle" />
                <p>
                  Program niedostępny ze względu na brak połączenia z serwerem.
                </p>
              </div>
            </template>
          </loader>
          <div class="columns see-more">
            <div
              class="column is-4 is-4-tablet is-12-mobile is-offset-4 is-offset-4-tablet"
            >
              <router-link
                to="/program"
                class="button is-primary is-fullwidth"
                @click.native="$immediatelyScrollToTop"
              >
                <icon name="fa-list" />
                <span>Pełny program</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="videos">
      <div
        class="column is-8-desktop is-offset-2-desktop is-12-tablet is-offset-0-tablet"
      >
        <div class="box">
          <p class="box-title">Najświeższe materiały</p>
          <loader :state="videosState">
            <div class="videos-list">
              <video-item
                v-for="video in videos"
                :key="video.id"
                :video="video"
                @click="$emit('go-to-video', $event)"
              />
            </div>

            <template #loading>
              <div class="spinner is-3by4 is-medium is-grey-lighter"></div>
            </template>

            <template #error>
              <div class="grey-message">
                <icon name="fa-times-circle" />
                <p>
                  Materiały niedostępne ze względu na brak połączenia z
                  serwerem.
                </p>
              </div>
            </template>
          </loader>
          <div class="columns see-more">
            <div
              class="column is-4 is-4-tablet is-12-mobile is-offset-4 is-offset-4-tablet"
            >
              <router-link
                to="/videos"
                class="button is-primary is-outlined is-fullwidth"
                @click.native="$immediatelyScrollToTop"
              >
                <icon name="fa-film" />
                <span>Archiwum</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <svg class="delimiter" viewBox="0 0 100 40" preserveAspectRatio="none">
      <path
        class="delimiter__shape"
        d="M 0 40 L 100 40 L 100 20 C 60 40 30 0 0 20 L 0 40"
      />
    </svg>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { Icon, Loader } from "%helpers";
import ProgramBlock from "%components/program/ProgramBlock";
import VideoItem from "%components/videos/VideoItem";

export default {
  name: "own-program",

  components: {
    Icon,
    ProgramBlock,
    VideoItem,
    Loader
  },

  props: {
    now: dayjs,
    program: Array,
    blocks: Object,
    today: dayjs,
    programState: [Array, String],
    videos: Array,
    videosState: [Array, String]
  },

  computed: {
    todayProgram() {
      return this.program.find(d => d.date === this.today.format("YYYY-MM-DD"));
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.own-program {
  background: url("../../assets/img/network.png") fixed no-repeat center / cover,
    linear-gradient(to bottom, $primary2 40%, $primary) fixed;

  @include until($widescreen) {
    background: linear-gradient(to bottom right, $primary2, $primary, $info);
  }
}

.delimiter {
  width: 100%;
  height: 25rem;
  display: block;

  @include tablet {
    height: 15rem;
  }

  @include mobile {
    height: 10rem;
  }

  @include until($small-mobile) {
    height: 7rem;
  }

  &__shape {
    fill: $white;
    stroke: $white;
  }
}

.box-title {
  font-family: $family-sans-serif;
  font-weight: 700;
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
  user-select: none;
}

.videos-list {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

.see-more {
  margin-top: 2rem;
}

.spinner {
  font-size: 4rem;
  margin: 0 auto;
}
</style>
